
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminDashboard from '@/components/admin/AdminDashboard';
import AdminUsers from '@/components/admin/AdminUsers';
import AdminRevenue from '@/components/admin/AdminRevenue';
import AdminSubscriptions from '@/components/admin/AdminSubscriptions';
import AdminPlans from '@/components/admin/AdminPlans';
import AdminRoles from '@/components/admin/AdminRoles';

const AdminPage = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="revenue" element={<AdminRevenue />} />
        <Route path="subscriptions" element={<AdminSubscriptions />} />
        <Route path="plans" element={<AdminPlans />} />
        <Route path="roles" element={<AdminRoles />} />
        <Route path="*" element={<Navigate to="/adm" replace />} />
      </Route>
    </Routes>
  );
};

export default AdminPage;
